module.exports = __webpack_public_path__ + "img/PayGate-Plus-White.cec63713.svg";